import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store"; // 👈 引入 store
import DataV from "@jiaminghi/data-view";
import * as echarts from "echarts";
import "echarts-gl";
import "echarts-liquidfill";
import axios from "axios";
import ElementUI from "element-ui";
// 引入全局css
import "./assets/styles/index.scss";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/fontFamily/font.css";

Vue.prototype.$echarts = echarts;
Vue.prototype.$axios = axios;
Vue.prototype.$store = store;

// datav组件
Vue.use(DataV);

// element组件
Vue.use(ElementUI);

Vue.config.productionTip = false;
new Vue({
	store, // 👈 挂载 store
	router,
	render: (h) => h(App)
}).$mount("#app");
